export default __webpack_public_path__ + "static/media/16_cowntains.3967fcfa.JPG";